import { useTranslation } from 'react-i18next';
import type { ProjectStatus } from '@interfaces/IProjectStatus.enum';
import type { ScheduleStatus } from '@interfaces/IProject';
import { StatusDotIcon } from '@utils/icons';
import styles from './styles.module.css';

const lifecycleLabelKey: Record<ProjectStatus, string> = {
  active: 'portfolio.status.active',
  planning: 'portfolio.status.planning',
  'on-hold': 'portfolio.status.onHold',
};

const scheduleLabelKey: Record<ScheduleStatus, string> = {
  onTrack: 'portfolio.status.onTrack',
  minorDelay: 'portfolio.status.minorDelay',
  late: 'portfolio.status.late',
  noData: 'portfolio.status.noData',
};

type IStatusBadgesProps = {
  lifecycle: ProjectStatus;
  schedule: ScheduleStatus;
  /** Sitting on a photo: give each badge an opaque base under its tint. */
  onImage?: boolean;
};

export function StatusBadges({ lifecycle, schedule, onImage }: IStatusBadgesProps) {
  const { t } = useTranslation();
  return (
    <span className={onImage ? `${styles.wrap} ${styles.onImage}` : styles.wrap}>
      {/* Nearly every project is active, so "Active" says nothing — only a
          project that is planning or on hold names its lifecycle. */}
      {lifecycle === 'active' ? null : (
        <span className={styles.lifecycle} data-state={lifecycle}>
          <StatusDotIcon />
          {t(lifecycleLabelKey[lifecycle])}
        </span>
      )}
      <span className={styles.schedule} data-state={schedule}>
        {schedule === 'noData' ? null : <StatusDotIcon />}
        {t(scheduleLabelKey[schedule])}
      </span>
    </span>
  );
}
